import React from 'react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
import { systemFeatures } from '../data/content';
export function SystemFeatures() {
  return <Section eyebrow="The solution" title="The clinical system for reducing unnecessary refinements" intro="Instead of another textbook full of theory, the Anti-Refinement System™ gives you a structured clinical workflow you can use throughout your aligner cases." data-id="element-223" data-mp="1uyt74w5hxx5t">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-224" data-mp="12bype702dbw1">
        {systemFeatures.map(item => <article key={item.title} className="rounded-3xl border border-white/10 bg-ink-800 p-5 transition hover:border-lime/40" data-id="element-225" data-mp="1c8bk987chvsd">
            <span className="text-2xl" aria-hidden="true" data-id="element-226" data-mp="177x7xdypnzoj">
              {item.icon}
            </span>
            <h3 className="mt-3 font-display text-base text-lime sm:text-lg" data-id="element-227" data-mp="2nlnh2z4ote51">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-228" data-mp="2io5fxuwww37l">{item.body}</p>
          </article>)}
      </div>

      <SectionCta headline="Get the complete clinical workflow — from screening to retention." data-id="element-229" data-mp="33jxq22wwk8q2" />
    </Section>;
}